import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { ITotalProps } from "./ITotalProps";
import { IReceipt } from "../../../types/IReceipt";
import { createOrder, saveReceiptRows } from "../../../services/Service";
import { IReceiptData } from "../../../types/IReceiptData";
import loadingImage from "../../../images/loading.gif";
import "./style.css";
import { ISaveRowsModal } from "./ISaveRowsModal";

export const SaveRowsModal: React.FC<ISaveRowsModal> = (
  props: ISaveRowsModal
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [toPayAmount, setToPayAmount] = React.useState("");
  const [payValue, setPayValue] = React.useState("");
  const [toPayType, setToPayType] = React.useState("Amount Due");
  const [payRemaining, setPayRemaining] = React.useState("");

  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);

  const buttonStyle = {
    width: "15vh",
    height: "10vh",
    fontSize: "4vh",
    fontWeight: "bolder",
    maxWidth: "100px",
    maxHeight: "100px",
    padding: 0,
  };

  const savingData = (): JSX.Element => {
    return (
      <>
        {error ? (
          <div className="loading-center">
            {/* <img src={loadingImage} alt="Loading" /> */}
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            Error in saving or printing. Please contact support on 07929-929070
          </div>
        ) : (
          <div className="loading-center">
            <img src={loadingImage} alt="Loading" />
          </div>
        )}
      </>
    );
  };

  const paymentScreen = () => (
    <>
      <>
        <div>
          {error ? (
            <Alert key="danger" variant="danger">
              Error saving receipt to table. Please try to save again. <br />
              If the error persist please contact support
            </Alert>
          ) : (
            <></>
          )}
        </div>
        <span style={{ fontSize: 16 }}>
          Receipt will be saved to : {context.Snooker.getSelected().description}
        </span>
      </>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Receipt saved</Modal.Title>
          </Modal.Header>
          <Modal.Body>{saving ? savingData() : paymentScreen()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <Button
              variant="success"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => okay()}
            >
              Save & Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  async function okay() {
    const rows = context.Receipt.getRows();
    const rowsJson = JSON.stringify(rows);

    const isSaved = await saveReceiptRows(
      context.Snooker.getSelected().uuid,
      context.AuthenticatedUser.getToken(),
      rowsJson
    );

    if (!isSaved) {
      setError(true);
      return;
    }

    props.close();
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
